import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, CDN_URL, formatDate, formatMoney, formatMoneyShorten, generateRandomString, getInlineLoaderMin, WEB_SOCKET_URL } from "../Helpers";
import { FaChalkboardTeacher, FaUser } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosAttach, IoIosImage, IoIosPeople, IoIosSend } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import SubscriptionExpiredWidget from '../ones/SubscriptionExpiredWidget';
import PersonalInfoUpdateWidget from '../ones/PersonalInfoUpdateWidget';
import { STR_CANCEL, STR_CLICK_TO_PICK_IMAGE, STR_FEMALE, STR_MALE, STR_NO_CHAT_WAS_FOUND, STR_NO_MESSAGES, STR_PLEASE_UPDATE_YOUR_PERSONAL_INFO, STR_SEND, STR_START_CHAT_WITH_MEMBER, STR_SUCCESS, STR_YES } from "../Strings";
import { TiUser } from "react-icons/ti";
import { BsImage } from "react-icons/bs";
import { MdImage } from "react-icons/md";


export default function View({ participantId }) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);
  const [data, setData] = useState(null);
  const [participantData, setParticipantData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [messageBody, setMessageBody] = useState("");
  const [isSendingMessage, setIsSendingMessage] = useState(false);
  const [messages, setMessages] = useState([]);

  const [showAttacher, setShowAttacher] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const webSocketRef = useRef(null)
  const [webSocketConnected, setWebSocketConnected] = useState(2); //0 = not, 1=conn, 2= start
  const [webSocketReconnectTimer, setWebSocketReconnectTimer] = useState(null);
  const wsRandomId = generateRandomString();


  async function init() {
    //run initializations here
    setReady(false);
    await getData().then((_data) => {
      if (_data) {
        setupWebSocket(_data.id);
      }
    });

    setReady(true);
  }

  function getData() {
    return new Promise(async (resolve) => {
      await callApi("get-chatroom", { participantId }).then(response => {
        if (response.status === 1) {
          setData(response.data);
          resolve(response.data);
        } else {
          resolve(false)
        }
      })
    })
  }


  async function setupWebSocket(chatRoomId) {
    //subscribe for chat data updates
    const user = appContext.currentUserData;
    webSocketRef.current = new WebSocket(WEB_SOCKET_URL);
    webSocketRef.current.addEventListener('open', async () => {
      //send subscription message
      // using delay hack
      setTimeout(async () => {
        if (webSocketRef.current.readyState === WebSocket.OPEN) {
          webSocketRef.current.send(JSON.stringify({
            type: 'subscribe-for-chatroom-data',
            userId: user.id,
            chatRoomId,
            userToken: user.token,
            sourceId: 'chatRoom' + wsRandomId,
          }))
        }
      }, 3000);
      setWebSocketConnected(1);
    })

    webSocketRef.current.addEventListener('close', (e) => {
      if (!e.wasClean) {
        setWebSocketConnected(0);
        //try to reconnect after 5 seconds
        setWebSocketReconnectTimer((prevTimer) => {
          if (prevTimer) {
            clearInterval(prevTimer);
          }

          let timer = setInterval(() => {
            setupWebSocket();
          }, 5000);

          return timer;
        })
      }
    })

    webSocketRef.current.addEventListener('message', (e) => {
      const response = JSON.parse(e.data);
      //console.log(response);
      //only update messages
      try {
        const _messages = JSON.parse(response.chatRoomData.messages);
        setMessages(_messages)
      } catch (error) {
        //console.log(error);

      }

    })


  }

  async function closeWebSocket() {
    //send unsubscribe req 
    const user = appContext.currentUserData;
    if (webSocketRef.current && webSocketRef.current.readyState === WebSocket.OPEN) {
      webSocketRef.current.send(JSON.stringify({
        type: 'unsubscribe-for-chatroom-data',
        userId: user.id,
        userToken: user.token,
        sourceId: 'chatRoom' + wsRandomId,
        chatRoomId: data?.id,
      }))
    }

    //then close connection
    if (webSocketRef.current) {
      webSocketRef.current.close();
    }

    //clear  reconnect timer
    if (webSocketReconnectTimer) {
      clearInterval(webSocketReconnectTimer);
    }
  }

  async function createChatroom() {
    setLoading(true);
    await callApi("create-chatroom", { participantId }).then(response => {
      if (response.status === 1) {
        appContext.tellMessage(STR_SUCCESS[appContext.language]);
        setData(response.data);
      } else {
        appContext.tellError(response.msg);
      }
    })
    setLoading(false);
  }

  async function sendMessage() {
    if (!isSendingMessage) {
      const messageAttachment = document.getElementById('_imagePicker').files[0];

      if (messageBody.trim().length > 0 || messageAttachment) {
        setIsSendingMessage(true);
        await callApi(
          "send-chatroom-message",
          {
            messageBody,
            messageAttachment: messageAttachment ? messageAttachment : '',
            chatRoomId: data.id,
          }
        ).then(response => {
          if (response.status === 1) {
            setMessageBody("");
            document.getElementById('_imagePicker').value = '';
            getData();
            appContext.getMyChatRooms();
          } else {
            appContext.tellError(response.msg);
          }
        })
        setIsSendingMessage(false);
      }
    }
  }

  function getSelectedImage(e) {
		// Ensure the event has a file input with a file selected
		if (e.target && e.target.files && e.target.files[0]) {
			const file = e.target.files[0];

			// Use FileReader to read the file and generate a URL
			const reader = new FileReader();

			// On load, set the result (URL) to an image src or handle it as needed
			reader.onload = function(event) {
				const fileURL = event.target.result;
				setSelectedImage(fileURL); // Replace with your image handling logic
			};

			// Read the file as a Data URL
			reader.readAsDataURL(file);
		} else {
      //..
		}
	}

  function getParticipantData() {

    if (data && data.participantsInfo) {
      for (const _participant of JSON.parse(data.participantsInfo)) {
        if (Number(_participant.userId) === Number(participantId)) {
          setParticipantData(_participant);
        }
      }
    }
  }

  function getMessages() {
    if (data && data.messages) {
      setMessages(JSON.parse(data.messages));
    }
  }

  useEffect(() => {
    init();

    return () => {
      closeWebSocket();
    }
  }, [participantId])

  useEffect(() => {
    if (messages && messages.length > 0) {
      //probably new message
      setTimeout(() => {
        try {
          document.getElementById(messages[messages.length - 1].messageId).scrollIntoView({
            behavior: "smooth",
          })
        } catch (error) {
          console.log(error);

        }
      }, 500)
    }
  }, [messages])

  useEffect(() => {
    getParticipantData();
    getMessages();
  }, [data])

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [loading])

  if (ready && data) {

    //..
    if (
      appContext.currentUserData.username &&
      appContext.currentUserData.username.trim().length > 0 &&
      appContext.currentUserData.gender
    ) {
      if (data.chatExists) {
        if (appContext.currentUserData.subscriptionStatus === 'active') {
          return (
            <div className="ChatRoom">
              <div className="header">
                <div
                  className="d-flex bg-background mShadow3 align-self-between"
                  style={{
                    height: "100%",
                    width: "100%",
                    padding: "10px",

                  }}
                >
                  <FaUser size={24} className="align-self-center mNoMargin text-secondary" style={{ flexShrink: "0" }} />
  
                  <h6
                    className="align-self-center mNoMargin mOneLineText font-bold text-secondary"
                    style={{
                      fontSize: "14px",
                      paddingLeft: "5px",
                      paddingRight: "20px",
                      textTransform: "capitalize",
                      flexGrow: "1",
                    }}
                  >
                    {participantData?.username}
                  </h6>
  
                  <span
                    className="badge bg-secondary align-self-center font-light"
                    style={{
                      fontSize: "12px",
                      flexShrink: "0",
                    }}
                  >
                    {(participantData?.gender === 'female') ? STR_FEMALE[appContext.language] : STR_MALE[appContext.language]}
                  </span>
                </div>
              </div>
  
              <div className="body">
                {
                  (messages && messages.length > 0) ?
                    messages.map((item, i) => {
                      return (
                        <div
                          key={i}
                          className="message"
                          id={item.messageId}
                          data-from-participant={(Number(item.userId) === Number(participantId))}
                        >
                          <div className="content">

                            {
                              (item.messageBody) ?
                              <pre>{item.messageBody}</pre>
                              :""
                            }

                            {
                              (item.messageAttachment) ?
                              <img
                                src={CDN_URL+item.messageAttachment}
                                style={{
                                  width: "100%",
                                  height: "auto",
                                }}
                              />
                              :""
                            }
  
                            <h6
                              style={{
                                fontSize: "10px",
                                marginTop: "8px",
                              }}
                            >
                              {formatDate(item.timestamp)}
                            </h6>
                          </div>
                        </div>
                      )
                    })
                    :
                    <h6
                      style={{
                        fontSize: "12px",
                        padding: "20px",
                      }}
                    >
                      {STR_NO_MESSAGES[appContext.language]}
                    </h6>
                }
              </div>
  
              <div className="footer bg-background">
                <div
                  className="d-flex"
                  style={{
                    height: "100%",
                    width: "100%",
                    padding: "10px",
                  }}
                >
                  <textarea
                    className="form-control"
                    style={{
                      height: "100%",
                      border: "1px solid var(--secondaryColor)",
                    }}
                    onChange={(e) => {
                      setMessageBody(e.target.value);
                    }}
                    readOnly={isSendingMessage}
                    value={messageBody}
                    maxLength={1000}
                  ></textarea>
  
                  <IoIosAttach
                    className="text-primary align-self-center"
                    size={30}
                    style={{
                      flexShrink: "0",
                      marginLeft: "5px",
                      marginRight: "5px",
                    }}
                    onClick={() => {
                      setShowAttacher(true);
                    }}
                  />
  
                  <div
                    className="mSupportLoadingMin align-self-center"
                    style={{
                      flexShrink: "0",
                      marginLeft: "5px",
                      marginRight: "5px",
                    }}
                  >
                    {
                      (isSendingMessage) ?
                        getInlineLoaderMin()
                        :
                        <IoIosSend
                          className="text-primary"
                          size={30}
                          onClick={sendMessage}
                        />
                    }
                  </div>
  
                </div>
              </div>

              <div 
                className="attacher"
                style={{
                  display: (showAttacher) ? "block" : "none",
                }}
              >
                <div
                  style={{
                    height: "10%",
                    width: "100%"
                  }}
                  className="text-center"
                >
                  <h6
                    style={{
                      fontSize: "12px"
                    }}
                  >
                    {STR_CLICK_TO_PICK_IMAGE[appContext.language]}
                  </h6>
                </div>

                <div
                  style={{
                    height: "70%",
                    width: "100%"
                  }}
                  className="text-center"
                  onClick={() => {
                    document.getElementById('_imagePicker').click();
                  }}
                >
                  <input
                    hidden
                    type="file"
                    accept="image/*"
                    id="_imagePicker"
                    onChange={getSelectedImage}
                  />
                  {
                    (selectedImage) ?
                    <img
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                      src={selectedImage}
                    />
                    :
                    <MdImage
                      style={{
                        width: "100%",
                        height: "100%",
                        opacity: "0.4"
                      }}
                    />
                  }
                </div>

                <div
                  style={{
                    height: "20%",
                    width: "100%"
                  }}
                  className="text-center"
                >
                  <button
                    className="btn btn-sm btn-rounded m-2 btn-primary"
                    onClick={() => {
                      setShowAttacher(false);
                      setSelectedImage(null);
                      sendMessage();
                    }}
                  >
                    {STR_SEND[appContext.language]}
                  </button>

                  <button
                    className="btn btn-sm btn-rounded m-2 btn-secondary"
                    onClick={() => {
                      setShowAttacher(false);
                      document.getElementById('_imagePicker').value = '';
                      setSelectedImage(null);
                    }}
                  >
                    {STR_CANCEL[appContext.language]}
                  </button>
                </div>
              </div>
  
            </div>
          )
        } else {
          return (
            <div className="container">
              <SubscriptionExpiredWidget />
            </div>
          )
        }
      } else {
        return (
          <div className="container">
            <div className="card">
              <div className="card-body text-center">
  
                <h6
                  className="text-muted font-light mb-4 mt-4"
                  style={{
                    fontSize: "24px",
                    textTransform: "capitalize",
                  }}
                >
                  <FaUser size={80} /> <br />
                  {participantData ? participantData.username : ""} <br />
                  {
                    participantData ?
                      <span
                        style={{ fontSize: "12px" }}
                        className="badge bg-secondary"
                      >
                        {(participantData.gender === 'female') ? STR_FEMALE[appContext.language] : STR_MALE[appContext.language]}
                      </span>
                      :
                      ""
                  }
                </h6>
  
                <h6
                  style={{
                    fontSize: "16px",
                  }}
                  className="font-semi-bold text-secondary text-center mb-4"
                >
                  {STR_NO_CHAT_WAS_FOUND[appContext.language]}. &nbsp;
                  {STR_START_CHAT_WITH_MEMBER[appContext.language]}?
                </h6>
  
                <button
                  className="btn btn-primary btn-rounded btn-padded"
                  onClick={createChatroom}
                >
                  {STR_YES[appContext.language]}
                </button>
              </div>
            </div>
          </div>
        )
      }
    } else {
      return (
        <div className="container">
          <PersonalInfoUpdateWidget title={STR_PLEASE_UPDATE_YOUR_PERSONAL_INFO[appContext.language]} />
        </div>
      )
    }
    //..
    
  } else {
    return (
      <div
        className="mSupportLoading container"
      >
        {getInlineLoader()}
      </div>
    );
  }


}